// Personalización del cargador de imágenes para Next.js 15
export default function imageLoader({ src, width, quality }) {
    // Implementa la lógica de carga de imágenes personalizada aquí
    // Ejemplo: si usas un CDN o servicio específico para imágenes
    const params = [`w=${width}`];

    if (quality) {
        params.push(`q=${quality}`);
    }

    // Si la URL ya es absoluta, devuélvela tal cual o añade parámetros si es necesario
    if (src.startsWith('http')) {
        return src.includes('?')
            ? `${src}&${params.join('&')}`
            : `${src}?${params.join('&')}`;
    }

    // Para URLs relativas
    return `${src}?${params.join('&')}`;
}
